import React, { useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import { dateFormatter } from "../../fomatters/DateFormatter";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function SystemProcessQueue() {
  const [refreshInterval, setRefreshInterval] = useState(5);

  const handleIntervalChange = (e) => {
    setRefreshInterval(e.target.value);
  };
  const typeFormatter = (value) => {
    switch (value) {
      case "G":
        return "Grade";
      case "U":
        return "Ungrade";
      case "B":
        return "Bonus Points";
      default:
        return value;
    }
  };

  return (
    <div className="flex flex-col gap-4 h-max">
      <Crud
        interval={refreshInterval * 1000} // Convertir a milisegundos
        title="System Process Queue"
        getUrl={() => `/Addons/SystemProcess_GetList`}
      >
        <TableHeaderColumn hidden isKey dataField="idSystemProcess">
          IdSystemProcess
        </TableHeaderColumn>
        <TableHeaderColumn dataField="processType" dataFormat={typeFormatter}>
          Type
        </TableHeaderColumn>
        <TableHeaderColumn hidden dataField="status">
          Status
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="requestingTime"
          dataFormat={dateFormatter}
          dataSort
        >
          Requested
        </TableHeaderColumn>
        <TableHeaderColumn dataField="loginName" dataSort>
          Requested by
        </TableHeaderColumn>
        <TableHeaderColumn dataField="phoneLine" dataSort>
          Phone Line
        </TableHeaderColumn>
        <TableHeaderColumn dataField="ip" dataSort>
          IP
        </TableHeaderColumn>
      </Crud>
      <div className="flex items-center gap-2">
        <label>Refresh every:</label>
        <input
          type="number"
          value={refreshInterval}
          onChange={handleIntervalChange}
          className="border p-1 rounded"
          min="1"
        />
        <span>seconds</span>
      </div>
    </div>
  );
}

export default SystemProcessQueue;
